<template>
  <div class="enterpriseDynamics">
    <div class="aa" @click="aa()">
    </div>


    <!-- 新闻列表 -->
      <div  v-if="indexs">
         <div v-for="(item,index) in newList">
          <div class="new-body" @click="ListDetail(1,item.id)">
            <div class="new-left">
                <img class="media-object" v-bind:src="item.img_url"  alt="">
            </div>
            <div class="new-right">
              <div class="new-right-l">
                 <h5 class="new-title">{{item.title}}</h5>
                 <span>{{dates[index]}}</span>
              </div>
              <p class="texts">
                  <span  v-html="item.describe"></span>
              </p>               
            </div>

         </div>
         <hr>
         
       
      </div>
  
       <!-- 页码切换 -->
      <!--<ul class="changePage">
        <li>首页</li>
        <li>上一页</li>
        <li v-for='n in totalpages' >{{n}}</li>
        <li>下一页</li>
        <li>尾页</li>
      </ul>-->
      </div>
   
      <!-- 新闻详情 -->
      <div v-if="indexs==false">
          <news-list-detail v-bind:id.sync='id'></news-list-detail>
      </div>
  </div>
</template>

<script>
import newsListDetail from '../detail/newsListDetail.vue'
export default {
  name: 'enterpriseDynamics',
  props:['indexs'],
  data () {
    return {
      id:0,
      newList:[],
      totalpages:0,
      dates:[]
    }
  },
  components:{
    'newsListDetail':newsListDetail
  },
  created(){
    this.getNewList();
  },
  methods:{
    aa () {
      this.indexs = true;
    },
    ListDetail (index,id) {
       this.indexs = false;
       this.id=id;
    },
    getNewList () {
      let self = this;
      const req = {
        index:1,
        size:10
      }
      this.$http.post('new/pageSelect/'+req.index+'/'+req.size,{}).then((data)=>{
        if(data.body.success){
            for(var i in data.body.data){
              self.newList.push(data.body.data[i]);
              var dat = data.body.data[i].create_date.substring(0,10);
              self.dates.push(dat);
              console.log(self.dates);
            
            }
            this.totalpages = Math.ceil(data.body.total/10)
						
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
*{
  text-align: left;
  font-family: 微软雅黑;
  letter-spacing: 1px;
  /*color: #2D2D2D;*/
  font-size: 13px;
  line-height: 26px;
}
h4{
  font-size: 16px;
  font-weight: border;
  color: black;
}
h5{
  font-size: 14px;
  text-align: left;
}
ul li{
  list-style-type: none;
}
.culture{
  padding-bottom: 50px;
}
 /* 内容主体 */
 .texts {
    position:relative;
    line-height:1.4em;
    /* 3 times the line-height to show 3 lines */
    height:4.2em;
    overflow:hidden;
}
.texts::after {
  content:"";
  font-weight:bold;
  position:absolute;
  bottom:0;
  right:0;
  padding:0 20px 1px 45px;
  background:url(http://newimg88.b0.upaiyun.com/newimg88/2014/09/ellipsis_bg.png) repeat-y;
   
}
.text-content{
  margin-top: 20px;
  margin-bottom: 50px;
}

.new-body{
  display: flex;
  margin-top: 20px;
}
.new-left{
  flex: 1;
}
.new-left img{
  width: 90%;
}
.new-right{
  flex: 2;
  margin-top: 10px;
}
.new-right .texts{
  font-size: 12px;
  text-align: left;
  color: #9a9a9a;
  line-height: 24px;
}
.new-right-l{
  display: flex;

}
.new-right-l span{
  flex:1;
  text-align: right;
  margin-top: 11px;
  padding-right: 8px
}
.new-title{
  flex: 3;
}

/*分页查询*/
  .changePage{
    display: -webkit-box;
    display: -moz-box; 
    display: -ms-flexbox; 
    display: -o-box; 
    display: box; 
    /*position: absolute;*/
    overflow: hidden;
    margin-top: 30px;
    /*left: 50%;*/
    margin-left: 33%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
  }
  .changePage li{
    border: solid 1px #ccc;
    height: 40px;
    margin: 20px 3px;
    line-height: 20px;
    padding: 8px 14px;
    display: inline-block;
    background: #ffecc3;
  }
  .aa{
    width: 255px;
    height: 40px;
    background-color: red;
    position: absolute;
    left: -270px;
    top: -35px;
    opacity:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/news/enterpriseDynamics.vue